import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import FallingText from './FallingText';

gsap.registerPlugin(ScrollTrigger);

const skillsText =
  'ChargeNest Donabox Solaranlagen Zutatenlupe PV-Netzplaner React.js Next.js App-Entwicklung iOS Android KI-Telefonassistenten Elektroarbeiten Webentwicklung Gestaltung Benutzererlebnis Dokploy Serververwaltung JavaScript Node.js IoT';

const AboutSection = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const quoteTopRef = useRef(null);
  const quoteBottomRef = useRef(null);
  const bgTextRef = useRef(null);
  const [fontSize, setFontSize] = useState('1.5rem');

  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth < 768 ? '0.75rem' : '1.5rem');
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const context = gsap.context(() => {
      gsap.fromTo(
        textRef.current.children,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: 'power4.out',
          stagger: 0.1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 60%',
            toggleActions: 'play none none reverse'
          }
        }
      );

      gsap.fromTo(
        bgTextRef.current,
        { x: -100 },
        {
          x: 100,
          ease: 'none',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        }
      );

      gsap.to(quoteTopRef.current, {
        y: -50,
        ease: 'none',
        scrollTrigger: { trigger: sectionRef.current, start: 'top bottom', end: 'bottom top', scrub: true }
      });
      gsap.to(quoteBottomRef.current, {
        y: 50,
        ease: 'none',
        scrollTrigger: { trigger: sectionRef.current, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }, sectionRef);

    return () => context.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="about"
      className="relative h-screen w-full bg-[#050505] flex flex-col items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0 opacity-60">
        <FallingText
          text={skillsText}
          trigger="scroll"
          gravity={0.2}
          fontSize={fontSize}
          mouseConstraintStiffness={0.2}
        />
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full select-none pointer-events-none z-0">
        <h1
          ref={bgTextRef}
          className="text-[25vw] font-black text-[#1a1a1a] opacity-30 text-center leading-none tracking-tighter will-change-transform"
        >
          ÜBER MICH
        </h1>
      </div>

      <div className="max-w-4xl w-full relative z-10 flex flex-col items-center px-6 pointer-events-none">
        <div className="text-center relative max-w-2xl mx-auto">
          <span
            ref={quoteTopRef}
            className="absolute -top-12 -left-4 md:-top-16 md:-left-12 text-6xl md:text-9xl font-serif text-white/20 select-none will-change-transform"
          >
            &ldquo;
          </span>

          <div ref={textRef} className="overflow-hidden relative z-10">
            <h2 className="text-xl md:text-2xl lg:text-3xl font-light italic text-gray-300 leading-relaxed tracking-wide font-['Manrope'] block">
              Ich verbinde physische Infrastruktur
            </h2>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-light italic text-gray-300 leading-relaxed tracking-wide font-['Manrope'] block">
              mit{' '}
              <span className="text-white font-normal not-italic border-b border-white/20 pb-0.5 inline-block">
                digitaler Code-Innovation
              </span>
              .
            </h2>
            <div className="h-6 block" />
            <span className="block mt-4 text-gray-400 font-light text-lg md:text-xl">
              Von Elektroarbeiten, Solaranlagen und Hardware-Lösungen
            </span>
            <span className="block text-gray-400 font-light text-lg md:text-xl">
              bis hin zu App-Entwicklung und KI-Systemen.
            </span>
            <span className="block text-gray-400 font-light text-lg md:text-xl">
              Ich biete ganzheitliche Tech-Lösungen,
            </span>
            <span className="block text-gray-400 font-light text-lg md:text-xl">
              die echten Mehrwert für Unternehmen
            </span>
            <span className="block text-gray-400 font-light text-lg md:text-xl">
              und Endkunden schaffen.
            </span>
          </div>

          <span
            ref={quoteBottomRef}
            className="absolute -bottom-12 -right-4 md:-bottom-16 md:-right-12 text-6xl md:text-9xl font-serif text-white/20 select-none will-change-transform"
          >
            &rdquo;
          </span>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
